import * as urlUtils from 'utils/Url';


export function getPathControlSegmentTemplates(qs={}) {
  return urlUtils.appendQueryString(`/control/segment-templates`, qs);
}

export function getPathControlAddSegmentTemplate() {
  return `/control/segment-templates/add`;
}

export function getPathControlEditSegmentTemplate(templateId) {
  return `/control/segment-templates/${templateId}/edit`;
}

